import { t } from 'i18next';
import { Button, Dialog, DialogProps, Paragraph } from '@expressable/syntax-ds';

export type RescheduleConfirmationResponse = 'success' | 'inactive' | 'notfound';

type Props = DialogProps & {
  onConfirm: () => void;
  status: RescheduleConfirmationResponse | null;
  isLoading?: boolean;
};

const RescheduleConfirmationModalMap = new Map([
  [
    'inactive',
    {
      title: t('reschedule.confirm.appointmentNoLongerValidTitle'),
      message: t('reschedule.confirm.appointmentNoLongerValidDescription'),
      cta: t('reschedule.confirm.selectNewAppointment'),
    },
  ],
  [
    'notfound',
    {
      title: t('reschedule.confirm.rescheduleNotFoundTitle'),
      message: t('reschedule.confirm.rescheduleNotFoundDescription'),
      cta: t('reschedule.confirm.selectNewAppointment'),
    },
  ],
  [
    'success',
    {
      title: t('reschedule.confirm.rescheduleSuccessTitle'),
      message: t('reschedule.confirm.rescheduleSuccessDescription'),
      cta: t('reschedule.confirm.rescheduleSuccessButton'),
    },
  ],
]);

export const RescheduleConfirmationDialog = ({ status, onConfirm, isLoading, ...dialogProps }: Props) => {
  if (!status) return null;
  return (
    <Dialog {...dialogProps}>
      <Dialog.Header>
        <Dialog.Title>{RescheduleConfirmationModalMap.get(status)?.title as string}</Dialog.Title>
      </Dialog.Header>
      <Dialog.Body>
        <Paragraph>{RescheduleConfirmationModalMap.get(status)?.message}</Paragraph>
      </Dialog.Body>
      <Dialog.CTAs>
        <Button onClick={onConfirm} disabled={isLoading}>
          {RescheduleConfirmationModalMap.get(status)?.cta}
        </Button>
      </Dialog.CTAs>
    </Dialog>
  );
};
